import type { HelpFile } from '../../types/help'
import { RoleDetailTestIds } from '../../../testids/RoleDetailTestIds'

export const roleDetailHelp: HelpFile = {
  docPage: '/docs/authorization/roles',
  texts: {
    [RoleDetailTestIds.roleDetailPage]: 'Role detail — the permissions it grants and the resources it covers in this application.',
    [RoleDetailTestIds.btnEditRole]: null,
    [RoleDetailTestIds.btnDeleteRole]: 'Delete this role — members lose its permissions immediately and the action cannot be undone.',
    [RoleDetailTestIds.btnEditPermissions]: 'Switch the permissions matrix into edit mode.',
    [RoleDetailTestIds.btnSavePermissions]: null,
    [RoleDetailTestIds.btnCancelEditPermissions]: 'Discard pending permission changes and exit edit mode.',
    [RoleDetailTestIds.cardTitlePermissions]: 'Resources and actions this role grants — toggle each cell to allow or deny.',
    [RoleDetailTestIds.colResource]: 'Resource type the row permissions apply to.',
    [RoleDetailTestIds.inputFilterPermissions]: 'Filter the matrix by resource or action name.',
    [RoleDetailTestIds.roleMetaCard]: 'Identity of this role — its OAuth claim key and human-readable description.',
    [RoleDetailTestIds.roleKeyValue]: 'Stable kebab-case key used to map upstream OIDC role claims onto this role. Read-only after create.',
    [RoleDetailTestIds.roleDescriptionValue]: 'Human-readable summary of what this role covers.',
  },
}
